<template>
    <div class="handles">
        <div v-for="(coord, i) in coords"
             class="handle"
             :data-handle="i">
        </div>
    </div>
</template>

<script type="text/babel">
    import ShapesConfiguration from '../../shapes-configuration';
    import EventBus from '../../event-bus';
    import Draggabilly from 'draggabilly';

    export default {
        props: {
            coords: Array,
            options: Object,
            shape: Object
        },

        data() {
            return {
                draggies: []
            };
        },

        mounted() {
            EventBus.$on('Handles:reset', this.resetHandles);

            setTimeout(() => {
                EventBus.$emit('Handles:reset', this.coords);
            });
        },

        beforeDestroy() {
            EventBus.$off('Handles:reset', this.resetHandles);
        },

        watch: {
            'options.width'() {
                EventBus.$emit('Handles:reset', this.coords);
            },

            'options.height'() {
                EventBus.$emit('Handles:reset', this.coords);
            }
        },

        methods: {
            placeHandle(coord) {
                return {
                    left: Math.round((coord[0] / 100) * this.options.width) + 'px',
                    top: Math.round((coord[1] / 100) * this.options.height) + 'px'
                };
            },

            resetHandles(coords) {
                let vm = this, handles = document.querySelectorAll('.handle');

                this.clearDraggies();

                this.coords = coords || JSON.parse(JSON.stringify(ShapesConfiguration[0].coords));

                for (let i = 0; i < handles.length; i++) {
                    let handle =  handles[i];
                    if (! handle.dataset.handle) {
                        return;
                    }

                    let i = handle.dataset.handle,
                        x = this.coords[i][0],
                        y = this.coords[i][1];

                    this.styleHandle(handle, this.coords[i]);
                    this.makeDraggable(handle);

                    vm.$emit('updateHandle', { x, y, i }, true);
                };
                EventBus.$emit('ClipPath:handlesReady');
            },

            clearDraggies() {
                for (let i = 0; i < this.draggies.length; i++) {
                    this.draggies[i].destroy();
                }
                this.draggies = [];
            },

            styleHandle(handle, coord) {
                Object.assign(handle.style, this.placeHandle(coord));
            },

            makeDraggable(handle) {
                let self = this, i = handle.dataset.handle;

                handle.classList.add('draggable');

                let draggie = new Draggabilly(handle, {
                    containment: true,
                    grid: [0, 0]
                }).on('pointerDown', function() {
                    document.querySelectorAll('[data-handle="' + i + '"]')[0].classList.add('changing');
                }).on('dragMove', function() {
                    let x = this.position.x;
                    let y = this.position.y;

                    self.$emit('updateHandle', { x, y, i });
                }).on('pointerUp', function() {
                    let elm = document.querySelectorAll('[data-handle]');
                    for (let i = 0; i < elm.length; i++) {
                        elm[i].classList.remove('changing');
                    }
                });

                this.draggies.push(draggie);
            }
        }
    }
</script>

<style lang="scss">
    .handles {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        .delete-point, .handle {
            position: absolute;
            width: 20px;
            height: 20px;
        }

        .handle {
            border-radius: 50%;
            box-shadow: inset 0 0 0 10px;
            opacity: .8;
            transition: opacity .25s;

            &.is-dragging,
            &.is-pointer-down { // better than using :hover/:active for touch
                z-index: 100;
                box-shadow: inset 0 0 0 3px;
                cursor: none;
                transition: box-shadow 0s;
            }

            &.draggable {
                cursor: grab
            }

            &.show-delete {
                .delete-point {
                    transform: scale3d(0.9, .9, .9);
                    transition: transform .25s cubic-bezier(0.15, 1, .3, 1.1), opacity .25s;
                    opacity: 1;
                }
            }

            &:after {
                display: block;
                content: "";
                position: absolute;
                top: -8px;
                left: -8px;
                right: -8px;
                bottom: -8px;
            }

            .delete-point {
                position: absolute;
                left: 22px;
                top: 0;
                width: 25px;
                padding-left: 5px;
                border-radius: 3px;
                background: #d3d0c9;
                transform: scale3d(0, 0, 0);
                transform-origin: left center;
                cursor: pointer;
                opacity: .75;
                clip-path: polygon(25% 0, 100% 1%, 100% 100%, 25% 100%, 0 50%);
                transition: transform .25s, opacity .25s;

                &:after {
                    display: block;
                    content: "";
                    position: absolute;
                    top: 4px;
                    left: 9px;
                    right: 4px;
                    bottom: 4px;
                    background: #100a09;
                    clip-path: polygon(20% 10%, 10% 20%, 40% 50%, 10% 80%, 20% 90%, 50% 60%, 80% 90%, 90% 80%, 60% 50%, 90% 20%, 80% 10%, 50% 40%);
                }
            }
        }
    }

    .playground:hover {
        .handle {
            opacity: 1;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ClipPath/Handles.vue